import { useEffect, useState } from "react";
import { useLoadableFeature } from "@hackler/react-sdk";
import { sessionStorage } from "@/utils/storage";

export const useCustomFeature = (experimentKey: number): boolean => {
  const [clientVariation, setClientVariation] = useState<boolean | null>(null);
  const { isLoading, isOn } = useLoadableFeature(experimentKey);

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.location.origin.includes("localhost")
    ) {
      const test_feature = sessionStorage.get("local_test_feature");

      if (test_feature === "false" || test_feature === "true") {
        setClientVariation(test_feature === "true");
      }
    }
  }, []);

  if (clientVariation !== null) {
    return clientVariation;
  }

  // 로딩 중일 때는 false 반환 (비활성화 유지)
  if (isLoading) {
    return false;
  }

  return isOn;
};
